import Icon from '../../components/Icon.vue'

Icon.register({"regular/chart-bar":{"width":512,"height":512,"paths":[{"d":"M500 400C506.6 400 512 405.4 512 412V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H36C42.6 64 48 69.4 48 76V400H500zM144 340V268C144 261.4 138.6 256 132 256H108C101.4 256 96 261.4 96 268V340C96 346.6 101.4 352 108 352H132C138.6 352 144 346.6 144 340zM240 340V140C240 133.4 234.6 128 228 128H204C197.4 128 192 133.4 192 140V340C192 346.6 197.4 352 204 352H228C234.6 352 240 346.6 240 340zM336 340V204C336 197.4 330.6 192 324 192H300C293.4 192 288 197.4 288 204V340C288 346.6 293.4 352 300 352H324C330.6 352 336 346.6 336 340zM432 340V108C432 101.4 426.6 96 420 96H396C389.4 96 384 101.4 384 108V340C384 346.6 389.4 352 396 352H420C426.6 352 432 346.6 432 340z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/chart-bar.js
// module id = EhjZ
// module chunks = 0